import { ColorFrom, DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import { IShadowFeature } from '../../../../effects/shadow/shadow-interface';
import { AngleFrom, ColorOperations, NumberInputFrom } from '@tencent/wb-ext-form';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export interface IChartShadowFeature extends IShadowFeature {
    handleShadowChange(value, dragEnd?: boolean, from?: NumberInputFrom | AngleFrom);
    handleShadowColorChange(tdColor: ITDColor, from: ColorFrom);
    getColorSelectButton();
    // updateUIWithShadowData();
    // renderPreset()
}

export const IChartShadowFeature = Symbol.for('feature:chart-global-drawer-shadow');

DynamicLoaderRegistry.merge(IChartShadowFeature, {
    useFactory: async () => {
        const { ChartShadowFeature } = await import('./chart-shadow-feature');
        return ChartShadowFeature;
    },
    on: loadTask,
});
